<template>
    <div class="mainContentAdmin" id="weblogCategories">
      <b-overlay :show="status" no-wrap fixed z-index="9999">
        <template v-slot:overlay>
          <div class="d-flex align-items-center">
            <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
            <b-spinner type="grow" variant="dark" class="mx-1"></b-spinner>
            <b-spinner small type="grow" variant="dark" class="mx-1"></b-spinner>
          </div>
        </template>
      </b-overlay>
      <div class="filters">
        <b-button v-if="getRole =='CalibrationLab'" variant="primary" @click="showModalFunction">افزودن </b-button>
      </div>
     <!-- <div v-if="items " class="mainTable"> -->
      <!-- <s-table
                     v-model="items"  
                     @showEditModal="showEditModal" 
                     @callModalFromTable="callModalFromTable"
                     customeFiledCallBack="item"
                    @deleteItem="deleteItem"
                    :settings="settings"
                    :headers="headers"
                  /> -->
       <!-- فیلتر برای ستون نام مشتري -->
    <!-- <input v-model="filters.statusName" placeholder="فیلتر بر اساس وضعيت" /> -->
  <div class="statusNameOption  ">  
    <p>فیلتر بر اساس وضعيت  </p>
    <multiSelect
       class="hiddenInMobile    "
        :placeholder="$cookie.get('ltrTheme') ? 'status Name order' : 'فیلتر بر اساس وضعيت'"
        id="sortOption"
        track-by="name"
        label="name"
        :show-labels="false"
        v-model="statusName"
        :options="statusNameOption"
      > 
      </multiSelect>
    </div>
     <div v-if="items " class="mainTable">
        <table v-if="items.length > 0" class="table table-hover">
          <tr class="trHeader">
            <th> شماره سفارش</th>
            <th>نام مشتري</th>
            <th>تاريخ ايجاد </th>
            <th> وضعيت </th>
            <th></th>
          </tr>
          <tr class="trDetail" v-for="item in items" :key="item.id" >          
            <td>
              {{ item.orderNumber }}
            </td>
            <td>
              {{ item.fullName }}
            </td>
            <td>
              {{ new Date(item.createDate).toLocaleDateString("fa") }}
            </td> 
            <td >
              <div v-if="item.statusId != 8 && item.statusId != 3" >
                  {{ item.statusName }}
              </div>
              <div v-else class="ColorStatusName" >
                  {{ item.statusName }}
              </div>
            </td>         
            <td>
            <td class="handlerSUp" >
              <div class="links">
              <!-- <b-button
                  v-if="item.statusId != 6"  
                  class="tableButtons"
                  variant="warning"
                  @click="showModalMessageModalFunction(item)"
                  >ارسال پیام
              </b-button > -->
             <!-- <b-button v-if="item.statusId != 6"  variant="info" @click="showDetail(item.id)"
              >مشاهده
            </b-button>  -->
            <b-button   variant="info" @click="callModalFromTable(item)"
              >مشاهده
            </b-button> 
            <b-button
              v-if="getRole =='CalibrationLab' && item.statusId == 1"
              class="tableButtons"
              variant="danger"
              @click="deleteItem(item.id)"
              >لغو سفارش
            </b-button>
           <!-- <div  v-if="getRole !='CalibrationLab'"   class="links">
            <b-button
              v-if=" item.statusId == 1"
              class="tableButtons"
              variant="success"
              @click="changeStatusOrder(item,2)"
              >تاييد سفارش
            </b-button>
            <b-button
              v-if=" item.statusId == 1"
              class="tableButtons"
              variant="danger"
              @click="changeStatusOrder(item,3)"
              >رد سفارش
            </b-button>
            <b-button
              v-if=" item.statusId == 2"
              class="tableButtons"
              variant="success"
              @click="changeStatusOrder(item,4)"
              >شروع کالیبراسیون 
            </b-button>
            <b-button
              v-if=" item.statusId == 4"
              class="tableButtons"
              variant="success"
              @click="changeStatusOrder(item,5)"
              >اتمام کالیبراسیون 
            </b-button>
            </div>  -->
          </div>
            </td>
            </td>              
          </tr>
        </table>
        <div class="noItems" v-else>
          <svg
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:osb="http://www.openswatchbook.org/uri/2009/osb"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns:ns1="http://sozi.baierouge.fr"
            id="svg2160"
            sodipodi:docname="OK-2.svg"
            viewBox="0 0 28.912 32.654"
            sodipodi:version="0.32"
            version="1.0"
            inkscape:output_extension="org.inkscape.output.svg.inkscape"
            inkscape:version="0.48.0 r9654"
          >
            <sodipodi:namedview
              id="base"
              fit-margin-left="0"
              inkscape:zoom="11"
              height="64px"
              borderopacity="1.0"
              inkscape:current-layer="layer1"
              inkscape:cx="10.569472"
              inkscape:cy="15.862443"
              fit-margin-right="2.7755576e-017"
              inkscape:grid-bbox="true"
              inkscape:window-maximized="0"
              showgrid="true"
              width="64px"
              inkscape:document-units="px"
              bordercolor="#666666"
              inkscape:window-x="137"
              inkscape:window-y="182"
              fit-margin-bottom="0"
              inkscape:window-width="1330"
              inkscape:pageopacity="0.0"
              inkscape:pageshadow="2"
              pagecolor="#ffffff"
              inkscape:window-height="900"
              fit-margin-top="0"
            />
            <g
              id="layer1"
              inkscape:label="Layer 1"
              inkscape:groupmode="layer"
              transform="translate(-20.653 -15.447)"
            >
              <path
                id="path3207"
                style="fill: #ff0000"
                inkscape:connector-curvature="0"
                d="m38.638 18.139c-1.798 1.5509-3.1446 4.3692-4.5312 5.8438-2.6315-2.177-3.8188-6.2358-6.6562-7.375-3.4407 0.91828-8.9042 4.1354-4.875 7.625 2.0576 3.0423 6.1945 5.7464 7.1562 8.9062-1.4673 3.7894-4.291 6.615-7.0312 9.375 1.3399 4.6754 7.7548 0.52478 10.344-1.75 2.0648-4.6338 3.5683 0.89824 5.4994 2.891 1.5405 6.2227 9.8042 4.4034 10.522-0.73944-2.8396-4.5489-6.7818-8.9244-9.521-13.402 1.0851-4.6542 5.6334-7.7704 6.6875-12.281-1.7893-3.1223-5.2813 0.35232-7.5938 0.90625z"
              />
              <path
                id="path3792"
                style="stroke: #a70000; fill: none"
                inkscape:connector-curvature="0"
                d="m38.638 18.139c-1.798 1.5509-3.1446 4.3692-4.5312 5.8438-2.6315-2.177-3.8188-6.2358-6.6562-7.375-3.4407 0.91828-8.9042 4.1354-4.875 7.625 2.0576 3.0423 6.1945 5.7464 7.1562 8.9062-1.4673 3.7894-4.291 6.615-7.0312 9.375 1.3399 4.6754 7.7548 0.52478 10.344-1.75 2.0648-4.6338 3.5683 0.89824 5.4994 2.891 1.5405 6.2227 9.8042 4.4034 10.522-0.73944-2.8396-4.5489-6.7818-8.9244-9.521-13.402 1.0851-4.6542 5.6334-7.7704 6.6875-12.281-1.7893-3.1223-5.2813 0.35232-7.5938 0.90625z"
              />
            </g>
            <metadata>
              <rdf:RDF>
                <cc:Work>
                  <dc:format>image/svg+xml</dc:format>
                  <dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage"
                  />
                  <cc:license
                    rdf:resource="http://creativecommons.org/licenses/publicdomain/"
                  />
                  <dc:publisher>
                    <cc:Agent rdf:about="http://openclipart.org/">
                      <dc:title>Openclipart</dc:title>
                    </cc:Agent>
                  </dc:publisher>
                  <dc:title>red not OK / failure symbol</dc:title>
                  <dc:date>2011-09-20T10:43:26</dc:date>
                  <dc:description>red not OK / failure symbol</dc:description>
                  <dc:source
                    >https://openclipart.org/detail/161515/red-not-ok--failure-symbol-by-antares42</dc:source
                  >
                  <dc:creator>
                    <cc:Agent>
                      <dc:title>Antares42</dc:title>
                    </cc:Agent>
                  </dc:creator>
                  <dc:subject>
                    <rdf:Bag>
                      <rdf:li>OK</rdf:li>
                      <rdf:li>button</rdf:li>
                      <rdf:li>failure</rdf:li>
                      <rdf:li>green</rdf:li>
                      <rdf:li>icon</rdf:li>
                      <rdf:li>not OK</rdf:li>
                      <rdf:li>red</rdf:li>
                      <rdf:li>success</rdf:li>
                    </rdf:Bag>
                  </dc:subject>
                </cc:Work>
                <cc:License
                  rdf:about="http://creativecommons.org/licenses/publicdomain/"
                >
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#Reproduction"
                  />
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#Distribution"
                  />
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#DerivativeWorks"
                  />
                </cc:License>
              </rdf:RDF>
            </metadata>
          </svg>
  
          <p>اطلاعاتی برای نمایش وجود ندارد</p>
        </div>
    </div>
    <!-- </div>  -->
     <div v-if="items != null && totalPages > 1">
      <div id="pagination">
        <pagination
          @pageChanged="pageChanged"
          :totalPages="totalPages"
          :currentPage="currentPage"
        />
      </div>
    </div> 
       <!-- <b-modal
        id="blogModal"
        hide-footer
        ref="blogModal"
        no-close-on-backdrop
        v-model="editModel"
        @close="resetModal()"
        :title="mode == 'create' ? 'افزودن سفارش ' + title : ' مشاهده ' + title"
      >       
           <s-inputs 
        :disabled="true"
        @submit="submit"
        :mode="mode"
        :folderRoute="'calibrationLabOrders'"
        :bigData="bigData"
        :settings="settings"
        :headers="headers.filter((item) => {
            return item.show_in_Form != false;
          })"
      />  -->
    <b-modal
      id="categoryModal"
      hide-footer
      ref="categoryModal"
      no-close-on-backdrop
      v-model="editModel"
      @close="resetModal()"
      title="مشاهده سفارش"
    >
      <div v-if="item" id="supplierContent">
        <img :src="item.image" :alt="item.title" />
        <div class="infoGroup">
          <div>
            <span> شماره سفارش :</span>
            <p>
              {{ item.orderNumber }}
            </p>
          </div>
          <div>
            <span>نام مشتري :</span>
            <p>
              {{ item.fullName }}
            </p>
          </div>
        </div>
        <div class="infoGroup">
          <div>
            <span>تاريخ ايجاد :</span>
            <p>
              {{ item.createDate }}
            </p>
          </div>
          <div>
            <span>وضعيت سفارش :</span>
            <p>
              {{ item.statusName }}
            </p>
          </div>
        </div>            
      </div>
      <!-- <button @click="callModalFromTable(item.orderNumber)">مشاهده جزییات</button> -->
      <!-- <div v-if="itemsList" class="mainTable">
        <table v-if="itemsList.length > 0" class="table table-hover">
          <tr class="trHeader">
            <th>شرح خدمات</th>
            <th> گستره</th>
            <th> توضيحات </th>
            <th> نوع </th>
            <th> قيمت </th>
            <th> تعداد </th>
            <th> قيمت كل</th>
          </tr>
          <tr class="trDetail" v-for="item in itemsList" :key="item.id" >          
            <td>
              {{ item.name }}
            </td>
            <td>
              {{ item.rang }}
            </td>
            <td>
              {{ item.description }}
            </td> 
            <td>
              {{ item.calibrationType }}
            </td>         
            <td>
              {{ item.price }}
            </td>  
            <td>
              {{ item.number }}
            </td>   
            <td>
              {{ item.priceLine }}
            </td>          
          </tr>
        </table>
      </div> -->
         <!-- <s-table
                    v-model="itemsList"
                    @showEditModal="showEditModal"
                    @callModalFromTable="callModalFromTable"
                    @deleteItem="deleteItem"
                    :settings="settings"
                    :headers="headersList"
                  />   -->
      <div v-if="itemsList" class="mainTable">
        <table v-if="itemsList.length > 0" class="table table-hover">
          <tr class="trHeader">
            <th>  شرح خدمات</th>
            <th>  گستره</th>
            <th>  توضيحات</th>
            <th>  نوع</th>
            <th> قيمت</th>
            <th> تعداد</th>
            <th>مبلغ كل </th>
          </tr>
          <tr class="trDetail" v-for="item in itemsList" :key="item.id" >
            <td>
              {{ item.name }}
            </td>
            <td>
              {{ item.range }}
            </td>
            <td>
              {{ item.description }}
            </td>
            <td>
              {{ item.calibrationType }}
            </td>
            <td>
              {{ item.price }}
            </td>
            <td>
              {{ item.number }}
            </td>
            <td>
              {{ item.priceLine }}
            </td>          
          </tr>
        </table>
      </div>
        <!-- <input class="btn btn-success" type="submit" value="ثبت" @click="submitCalibrationLabOrder()" />     -->
    </b-modal>
    <b-modal
        id="blogModal"
        hide-footer
        ref="blogModal"
        no-close-on-backdrop
        v-model="showModal"
        @close="resetModal()"
        :title="mode == 'create' ? 'افزودن سفارش ' + title : ' مشاهده ' + title"
      >
       <!-- <s-table
                    v-model="itemsActive"
                    @showModal="showModal"
                    @deleteItem="deleteItem"
                    :settings="settings"
                    :headers="headersList"
                  /> -->
        <!-- <div v-if="itemsActive" class="mainTable"> -->
           <table v-if="itemsActive" class="table table-hover">
          <tr class="trHeader">
            <th>  شرح خدمات</th>
            <th>  گستره</th>
            <th>  توضيحات</th>
            <th>  نوع</th>
            <th> قيمت</th>
            <th> تعداد</th>
            <th>مبلغ كل </th>
          </tr>
          <tr class="trDetail" v-for="itemL in itemsActive" :key="itemL.id" >
            <td>
              {{ itemL.name_fa }}
            </td>
            <td>
              {{ itemL.range }}
            </td>
            <td>
              {{ itemL.description }}
            </td>
            <td>
              {{ itemL.calibrationType }}
            </td>
            <td>
              {{ itemL.price }}
            </td>
            <td>
              <!-- <input type="number"  class="text-center"  v-model="itemL.number"  placeholder=" تعداد را وارد نماييد." /> -->
              <input type="number"  class="text-center"  v-model.number="itemL.number" min="0" placeholder="تعداد را وارد نماييد."/>
            </td>
            <td>
              {{   (itemL.number || 0) * (itemL.price || 0)  }}
            </td>          
          </tr>
          </table>         
          <table class="table text-right">
          <tr class="trDetail">
            <td style="text-align: right;font-weight: bold;"> مالیات: </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td  style="text-align: left;font-weight: bold;">  {{  taxOnCart }} </td>
          </tr>
          <tr class="trDetail">
            <td style="text-align: right;font-weight: bold;"> مبلغ نهايي:</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
             <td  style="text-align: left;font-weight: bold;">  {{ finalAmountWithTax }}</td>
          </tr>
          </table> 
        <!-- </div>    -->
       <input  v-if="disabled == false" class="btn btn-success " type="submit" value="ثبت" @click="submitCalibrationLabOrder()" />
       <b-button v-else class="disableLink" type="button" variant="primary"> در حال ثبت </b-button>
      </b-modal>
      <b-modal
      id="blogModal"
      hide-footer
      ref="blogModal"
      no-close-on-backdrop
      v-model="showModalMessageModal"
      @close="resetModal()"
      title="ارسال پیام"
    >
      <b-form-group label="پیام" class="headerStyle">
        <b-form-textarea v-model="message" placeholder="پیام را وارد کنید">
        </b-form-textarea>
      </b-form-group>
      <b-button variant="primary" @click="sendMessage()"> ارسال پیام </b-button>
    </b-modal>
    </div>
  </template>
  <script>
  import multiSelect from "vue-multiselect";
  import pagination from "@/components/front/shared/pagination.vue";
  import SInputs from "@/components/admin/shared/sInputs.vue";
  import STable from "@/components/admin/shared/sTable.vue";
  import adminMixin from "@/libraries/adminController.js";
  import { BModal, BButton, BOverlay, BSpinner , BFormGroup, BFormTextarea,} from "bootstrap-vue";
  export default {
    mixins: [adminMixin],
    components: {
      SInputs,
      BModal,
      BButton,
      STable,
      BOverlay,
      BSpinner,
      pagination,
      BFormGroup,
      BFormTextarea,
      multiSelect
    },
    data() {
      return {
      search: "",
      statusName: null,
       statusNameOption: [
        { name: this.$cookie.get("ltrTheme") ? "All Items" : "همه موارد", value: "0"},
        { name: this.$cookie.get("ltrTheme") ? "SavedOrder" : "ثبت سفارش", value: "1"},
        { name: this.$cookie.get("ltrTheme") ? "ConfirmOrder" : "تایید سفارش", value: "2" },
        { name: this.$cookie.get("ltrTheme") ? "RejectOrder" : "رد سفارش", value: "3" },
        { name: this.$cookie.get("ltrTheme") ? "ReceiveEquipment" : "دریافت تجهیزات", value: "4" },
        { name: this.$cookie.get("ltrTheme") ? "StartCalibration" : "شروع کالیبراسیون", value: "5" },
        { name: this.$cookie.get("ltrTheme") ? "AwaitingPayment" : "در انتظار پرداخت", value: "6" },
        { name: this.$cookie.get("ltrTheme") ? "EndCalibration" : "اتمام کالیبراسیون", value: "7" },
        { name: this.$cookie.get("ltrTheme") ? "CancelCalibration" : "لغو سفارش", value: "8" }
      ],
       // filters: {
        //  statusName: '',
      //},
      // statusName:null,
       // number:0,
        disabled:false,
        headersList: [
          {
            style: "col-12",
            show_in_table: false,
            placeholder: " شرح خدمات را وارد کنید",
            type: "number",
            multiData: false,
            name: "Id",
            key: "Id"
          },
         {
            style: "col-12",
            show_in_table: true,
            placeholder: " شرح خدمات را وارد کنید",
            type: "string",
            multiData: false,
            name: "شرح خدمات",
            key: "name_fa"
          },
          {
            style: "col-12",
            show_in_table: true,
            placeholder: "گستره را وارد کنید",
            type: "string",
            multiData: false,
            name: "گستره",
            key: "range"
          },
          {
            style: "col-12",
            show_in_table: true,
            placeholder: " توضيحات راوارد کنید",
            type: "description",
            multiData: false,
            name: "توضيحات",
            key: "description"
          },
          {
            style: "col-6",
            show_in_table: true,
            placeholder: "نوع را انتخاب کنید",
            type: "select",
            multiData: false,
            name: "نوع",
            multiple: false,
            selectIN: "selectListType",
            key: "calibrationType"
          },
          {
            style: "col-6",
            show_in_table: true,
            placeholder: "قيمت را وارد کنید",
            type: "number",
            multiData: false,
            name: "قيمت",
            selectIN: "selectListType", 
            key: "price"
          },
          {
            style: "col-12",
            show_in_table: true,
            placeholder: "تعداد را وارد کنید",
            type: "number",
            multiData: true,
            name: "تعداد",
            key: "number",
            //editModel:true,
            //, editable: true,
           // isEditing:true,
            //edit: true,
          },
          {
            style: "col-12",
            show_in_table: true,
            placeholder: "مبلغ كل را وارد کنید",
            type: "number",
            multiData: true,
            name: "مبلغ كل",
            key: "priceLine",
            editModel:true
            ,edit: true
          }
        ],
        pageSize: 20,
        bigData: {
          persian: {},
          english: {},
          both: {}
        },
        title: "آزمايشگاه كاليبراسيون",
        editedId: null,
        // apiRoute: "CalibrationLab/GetCalibrationLabActiveList",
        apiRoute: "CalibrationLabOrder",
      // //  ,length:10
      //  // length:10

        //items: null,
        //apiRoute: "CalibrationLab/GetCalibrationLabList",
        sendModal: false,
        editModel:false,
        showModal: false,
        status: true,
        item: null,
        userId: null,
       // message: "",
        currentPage: 1,
        totalPages: 1,
        OrderNumber:null,
        headers: [
         // headers: [
          {
            style: "col-6",
            show_in_table: false,
           // placeholder: " شرح خدمات را وارد کنید",
            type: "number",
            multiData: false,
            name: "Id",
            key: "id"
          },
         {
            style: "col-6",
            show_in_table: true,
            placeholder: " شماره سفارش را وارد کنید",
            type: "string",
            multiData: false,
            name: "شماره سفارش",
            key: "orderNumber"
          },
          {
            style: "col-6",
            show_in_table: true,
            placeholder: "نام  را وارد کنید",
            type: "string",
            multiData: false,
            name: "نام مشتري",
            key: "fullName"
          },
          {
            style: "col-6",
            show_in_table: true,
            placeholder: " تاريخ ايجاد راوارد کنید",
            type: "date",
            multiData: false,
            name: "تاريخ ايجاد",
            key: "createDate"
          },
          {
            style: "col-6",
            show_in_table: true,
            placeholder: "  وضعيت سفارش راوارد کنید",
            type: "string",
            multiData: false,
            name: "وضعيت سفارش",
            key: "statusName"
          },
          {
            style: "col-6",
            show_in_table: false,
            show_in_Form: false,
            placeholder: "  وضعيت سفارش راوارد کنید",
            type: "number",
            multiData: false,
            name: "وضعيت سفارش",
            key: "statusId"
          },
        {
          style: "col-6",
          show_in_table: true,
          placeholder: "",
          type: "setting",
          name: "تنظیمات",
          multiData: false,
          key: "",
          //innerRoute: "/admin-panel/product-feature",
         // edit: true,
          delete: true,
          deleteLabel:"لغو سفارش",
         // editLabel: "مشاهده",
          show:true,
          buttonModalTitle: " مشاهده",
          //buttonModalTitle: "پيام",
          //sendMessage:true,
          
          modal: true,
          //message:true,
        //  editable: true  // یا false بر اساس شرط مورد نظر
        }
        ],
       // itemsOrders:null,
        itemsList:null,
        itemsActive:null,
        showModalMessageModal: false,
        Id:null,
         message: "",
       // statusName:null
      };
    },
    computed: {
    getRole() {
     // debugger;
      if (this.$store.getters.getAdminPanelRole == null) {
        return "";
      } else {
        return this.$store.getters.getAdminPanelRole;
      }
    },
    totalAmount() {
      //debugger;
      if(this.itemsActive != null)
      {
        return this.itemsActive.reduce((sum, item) => {
         //const itemTotal = (item.price * (item.number || 0)) ;
        // item.priceLine = (item.price * (item.number || 0));
         const price = Number(item.price) || 0;
        const number = Number(item.number) || 0;
        const itemTotal = price * number;
        return sum + itemTotal;
       // return sum + Math.max(0, itemTotal);
        
         }, 0);
      }
       else
       {
         return 0;
        }
     },
     taxOnCart() {
      //debugger;
       const taxRate = 0.10;
       return this.totalAmount * taxRate; 
     },
    finalAmountWithTax() {
     // debugger;
       return  this.totalAmount + this.taxOnCart; 
     }
   },
    mounted() {
      if (this.$route.query.page) {
        this.currentPage = this.$route.query.page;
      } else {
        this.currentPage = 1;
      }
       //this.loadSettings([{ route: "ProductCategory", field: "name" },{ route: "Brand", field: "title" },{ route: "UnitProduct", field: "title" }]) 
        this.settings['selectListType']=[ {id:'1',label:'فشار'}, {id:'2',label:'دما'}];
       // this.settings['statusNames']=[ {id:'1',label:'ثبت سفارش'}, {id:'2',label:'تایید سفارش'},{id:'3',label:'رد سفارش'},{id:'4',label:'دریافت تجهیزات'},{id:'5',label:'شروع کالیبراسیون'},{id:'6',label:'در انتظار پرداخت'},{id:'7',label:'اتمام کالیبراسیون'},{id:'8',label:'لغو سفارش'}];
      this.loadItems(this.currentPage);
      this.getId();
    },
    watch: {
      item(newVal) {
        this.bigData = newVal;
      },
    //   statusName(newVal) {
    //   // this.filterList.push(newVal);
    //   let filter = {
    //    // isDesending: this.sort != null ? this.sort.value : true,
    //    statusName: this.statusName != null ? this.statusName.value : 1,
    //     search: this.search
    //   };
    //   this.$emit("filtered", filter);
    // },
    statusName()
    {
      this.handlerRequest();
    }
    },
    methods: {
      handlerRequest() {
        this.isSuccess = "falsefalse";
        if(this.statusName.value != 0 && this.statusName.value != null){
       
           this.$axios.get(`${this.apiRoute}/${this.currentPage}/${this.pageSize}`).then((response) => {
           this.status = false;
           //this.items = response.data.data;
           this.items = response.data.data.filter(item => item.statusId ==  Number(this.statusName.value))
         //  this.items = this.items.filter(item => item.statusId ==  Number(this.statusName.value))
          })
            .catch((err) => {
              this.isSuccess = false;
              this.$toast.error(err.response.data.message);
            });
           
        }else{
          this.$axios.get(`${this.apiRoute}/${this.currentPage}/${this.pageSize}`).then((response) => {
           this.status = false;
           this.items = response.data.data;
          })
            .catch((err) => {
              this.isSuccess = false;
              this.$toast.error(err.response.data.message);
            });
        }
      },
    sendMessage(item) {
      let pack = {
        userId: this.userId,
        message: this.message,
        CalibrationLabOrderId: this.Id,
        isRead: false,
        forAdmin: true,
        replyTo: null,
      };
      this.$axios
        .post(`CalibrationLabMessage`, pack)
        .then((res) => {
          this.$toast.success("پیام شما با موفقیت ارسال شد");
          this.message = "";
          this.showModalMessageModal = false;
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message);
        });
    },
    showModalMessageModalFunction(item) {
      this.Id = item.id;
      this.showModalMessageModal = true;
      setTimeout(() => {
        document
          .getElementById("blogModal___BV_modal_content_")
         // .removeAttribute("tabindex");
      });
    },
    callModalFromTable(item){
      this.sendModal=true;
      this.userId=item.userId;
  
      //
      this.$router.push(`/admin-panel/calibrationLabOrder-detail?id=${item.id}`);
    },
    //-------------------------------------
    changeStatusOrder(item,statusIdNew){
      let pack = {
        statusId : statusIdNew,
        userId: this.userId,
        orderNumber: item.orderNumber,
      };
      this.$axios
        .post("CalibrationLabOrder/ChangeCalibrationLabOrdeStatus", JSON.stringify(pack), {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json",
          },
        })
        .then(() => {
               this.$toast.success(".ثبت با موفقیت انجام گرديد");
        })
        .catch((error) => {
          this.disabled = false;
          let arrayError = error.response.data.message.split("|");
          arrayError.forEach((err, index) => {
            if (index < 1) {
              this.$toast.error(err, {
                timeout: 1000 * (index + 4),
                pauseOnHover: true,
              });
            }
          });
        });
    },
    showDetail(id) {
      this.editedId = id;
      this.status = true;
      this.$axios.get(`${this.apiRoute}/${id}`).then((response) => {
        //debugger;
       // this.newsCode = response.data.data.code;
        this.status = false;
        this.item = response.data.data;//this.convertToBigData(response.data.data);
      });
      this.mode = "edit";
      //this.showModal = true;
      this.editModel = true;
      setTimeout(() => {
        document
          .getElementById("blogModal___BV_modal_content_")
          .removeAttribute("tabindex");
      });
      //---------------------------------
       this.$axios.get(`CalibrationLabOrder/GetOrdersDetail?Id=${id}`).then((res) => {
        this.itemsList = res.data.data;
       // debugger;
       // this.showModal = true;
       this.editModel = true;
         });
    },
    showModalFunction() {
    //debugger;
      this.showModal = true;
      this.OrderNumber = null;
      this.$axios.get("CalibrationLabOrder/GetLastOrderNumber").then((res) => {
       // this.bigData.both.OrderNumber = res.data.data;
        this.OrderNumber = res.data.data;
      });
      //--------------------------------
      this.$axios.get("CalibrationLab/GetCalibrationLabActiveList").then((res) => {
       this.itemsActive = res.data.data;
       //this.showModal = true;
      });
      setTimeout(() => {
        document
          .getElementById("blogModal___BV_modal_content_")
          .removeAttribute("tabindex");
      });
    },
    async  submitCalibrationLabOrder(){
       //debugger;
   this.disabled=true;
   var CountItems=0;
   for(let item in this.itemsActive)
    {
      //if(this.itemsActive[item].type != null && this.itemsActive[item].type != 0){
     if(this.itemsActive[item].number != null && this.itemsActive[item].number != 0){
        CountItems ++;
      }}
   //------------------------------------------
   var Counts=0;
    for(let item in this.itemsActive)
    {
     // if(this.itemsActive[item].type != null && this.itemsActive[item].type != 0)
      if(this.itemsActive[item].number != null && this.itemsActive[item].number != 0)
      {
        Counts ++;
      let pack = {
        calibrationLabId: this.itemsActive[item].id,
        userId: this.userId,
        number: (this.itemsActive[item].number || 0), // this.itemsActive[item].type,
        price: this.itemsActive[item].price ,
        priceLine: (this.itemsActive[item].price || 0) *  (this.itemsActive[item].number || 0),
        OrderNumber:this.OrderNumber
      };
      this.disabled = true;
      //debugger;
       this.$axios
        .post("CalibrationLabOrder/CreateCalibrationLabOrder", JSON.stringify(pack), {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json",
          },
        })
        //.then(() => {
         // StatusSave = true;
        //  debugger;
        //  if(Counts == CountItems){
           //this.$toast.success(".ثبت با موفقیت انجام گرديد");
        //  }
          // this.fullName = "";
          // this.text = "";
          // this.disabled = false;
          // this.email = "";
          // this.mobile = "";
          // this.showModal = false;
        //})
        // .catch((error) => {
        //   this.disabled = false;
        //   let arrayError = error.response.data.message.split("|");
        //   arrayError.forEach((err, index) => {
        //     if (index < 1) {
        //       this.$toast.error(err, {
        //         timeout: 1000 * (index + 4),
        //         pauseOnHover: true,
        //       });
        //     }
        //   });
        // });
      }}
      //--------------------------------------------
      let pack1 = {
        userId: this.userId,
        OrderNumber:this.OrderNumber
      };
      await this.$axios
        .post("CalibrationLabOrder/CreateCalibrationLabOrderStatus", JSON.stringify(pack1), {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json",
          },
        })
        .then(() => {
               this.$toast.success(".ثبت با موفقیت انجام گرديد");
               this.resetModal();
               this.loadItems();
               this.disabled=false;
          })
          .catch((error) => {
          this.disabled = false;
          let arrayError = error.response.data.message.split("|");
          arrayError.forEach((err, index) => {
            if (index < 1) {
              this.$toast.error(err, {
                timeout: 1000 * (index + 4),
                pauseOnHover: true,
              });
            }
          });
        });
        //--------------------------------------------
      // if(Counts == CountItems){
      //     this.$toast.success(".ثبت با موفقیت انجام گرديد");
      //     this.resetModal();
      //     this.loadItems(this.currentPage);
      //    }
    },
    resetSendModal() {
        this.message = "";
        this.sendModal = false;
    },
    loadItems() {
        this.$axios.get(`${this.apiRoute}/${this.currentPage}/${this.pageSize}`).then((response) => {
        this.status = false;
        this.items = response.data.data;
        //--------------------------------------
      //   const n = this.filters.statusName.toLowerCase();
      // // اگر فیلتر خالی بود، همه items را برمی‌گرداند
      // if (!n) return this.items;
      // return this.items.filter(it =>
      //   String(it.statusName || '')
      //     .toLowerCase()
      //     .includes(n)
      // );
       
      });
    },
    }
  };
  </script>
  <style scoped>
  .statusNameOption{
    float: right;
    margin: 10px;
    text-align: right;
  }
  .disableLink {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
  .ColorStatusName{
    color: red;
  }
.modal-dialog {
  font-size: 12px;
}
/* tr.trHeader th,
tr.trDetail td {
    text-align: center;
    padding: 0;  
    vertical-align: middle;
} */

div#supplierContent p {
  background: #80808042;
  padding: 10px 20px;
  min-width: 100%;
  min-height: 50px;
  direction: rtl;
  text-align: right;
}
div#supplierContent span {
  background: #80808042;
  padding: 10px 20px;
  min-width: 200px;
  text-align: right;
  direction: rtl;
  font-weight: bolder;
}
div#supplierContent img {
  width: 210px;
  margin: auto;
}
div#supplierContent {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
  padding: 15px;
}
.infoGroup div {
  display: flex;
  flex-direction: column;
}

.infoGroup {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  justify-content: space-between;
  gap: 10px;
  direction: rtl;
}

div#sendMessageContent textarea {
  padding: 15px;
}
div#sendMessageContent input[type="submit"] {
  background: green;
  color: white;
  padding: 10px 24px;
  border: chartreuse;
  border-radius: 4px;
}

div#sendMessageContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  direction: rtl;
}
.headerStyle {
  direction: rtl;
  text-align: right;
}
.links {
  display: flex;
  gap: 8px;
}
</style>
  